export default "__VITE_ASSET__c2d8a00a__"